import React from 'react';
import { createBrowserHistory } from 'history';
import DocumentMeta from 'react-document-meta';
import { Row, Col, Layout, Menu, Avatar, Typography, Space, Button, Tooltip, Popconfirm  } from 'antd';
import { Link } from 'react-router-dom';
import Cookie from 'js-cookie';
import {
  ShoppingCartOutlined,
  LineChartOutlined,
  TableOutlined,
  NodeIndexOutlined,
  UserOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  WalletOutlined,
  InfoCircleTwoTone,
  CloudDownloadOutlined,LogoutOutlined,
} from '@ant-design/icons';

const { Header, Sider, Content, Footer } = Layout;
const { SubMenu } = Menu;
const { Text } = Typography;

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: true, // Boolean(localStorage.getItem('LW_SIDER_collapsed')),
      current: '',
    };
  }

  componentDidMount() {
  }
  // shouldComponentUpdate(nextProps, nextState) {
  //   console.log(111, this.state.collapsed, nextState.collapsed);
  //   return true;
  // }
  handleClick = (e) => {
    console.log('click ', e.key, e);
    this.setState({
      current: e.key
    });
  }

  toggle = () => {
    localStorage.setItem('LW_SIDER_collapsed', !this.state.collapsed);
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };
  forcereload = () => {
    sessionStorage.clear();
    window.location.reload(true);
  }
  logout = () => {
    
    localStorage.setItem('userId', '');
    localStorage.setItem('username', '');
    localStorage.setItem('realname', '');
    localStorage.setItem('userToken', '');
    localStorage.setItem('userRoles', '');
    localStorage.setItem('dividersIdCurrent', '');
    
    Cookie.set('userId', '');
    Cookie.set('username', '');
    Cookie.set('realname', '');
    Cookie.set('userToken', '');
    Cookie.set('userRoles', '');
    Cookie.set('dividersIdCurrent', '');
    createBrowserHistory().push('/#/login/');
    window.history.go(0);
  }
  render() {
    const uname = localStorage.getItem('realname');
    return (
      <DocumentMeta {...this.props.meta} title={`${this.props.meta?.title || ''} | 第5季旅游-管理系统`}>
      <Layout className={`${this.props.className} main-submenu`}>
        <Sider
          width={200}
          className="site-layout-background site-sider"
          trigger={null}
          collapsible
          collapsed={this.state.collapsed}
        >
          {
            this.state.collapsed ?
              (
                <div className="logo1"><img src='/logo1.jpg' /></div>
              )
              :
              (
                <div className="logo"><img src='/logo.jpg' /></div>
              )
          }
          <div></div>
          <Menu
            theme="dark1"
            mode="inline"
            // defaultSelectedKeys={[]}
            defaultOpenKeys={[]}
            style={{ height: '100%', borderRight: 0 }}
            onClick={this.handleClick}
            selectedKeys={[this.state.current]}
            defaultSelectedKeys={['sub2']}
          >
            <SubMenu key="sub1" icon={<ShoppingCartOutlined />} title="销售">
              <Menu.Item key="orders"><Link to='/orders/1'>订单</Link></Menu.Item>
              <Menu.Item key="orders-mbill"><Link to='/orders-bill/manualclaim'>团款认领</Link></Menu.Item>
              <Menu.Item key="local-groups"><Link to='/orders/groups/'>组团计划</Link></Menu.Item>
            </SubMenu>
            <SubMenu key="sub2" icon={<LineChartOutlined />} title="报表">
              <SubMenu key="sub2-0" title="业绩统计">
                <Menu.Item key="/report:3-0"><Link to='/report/statistics/'>实时统计</Link></Menu.Item>
                <Menu.Item key="/report:3-1"><Link to='/report/department-month-incomes/'>月度营收统计（预定/出行）</Link></Menu.Item>
                {/* <Menu.Item key="/report:demo"><a target='_blank' href='https://www.5seasontour.com/public/sjkb/index.html'>综合看板</a></Menu.Item> */}
                <Menu.Item key="/report:3-2"><Link to='/report/statistics/advance'>地区</Link></Menu.Item>
                <Menu.Item key="/report:3-3"><Link to='/report/statistics/products'>产品</Link></Menu.Item>
                <Menu.Item key="/report:3-4"><Link to='/report/statistics/sales'>销售员</Link></Menu.Item>
              </SubMenu>
              <SubMenu key="sub2-1" title="客人数据">
                <Menu.Item key="/report:4-0"><Link to='/report/crm/'>统计</Link></Menu.Item>
                <Menu.Item key="/report:4-1"><Link to='/report/crm/traveller/1'>列表</Link></Menu.Item>
              </SubMenu>
              <Menu.Item key="/report:2-0"><Link to='/report/all/'>OTA</Link></Menu.Item>
              <Menu.Item key="/report:2-1"><Link to='/report/tct/'>平台运营</Link></Menu.Item>
              <Menu.Item key="/report:2-2"><Link to='/report/roi/'>OTA - 广告费投产表</Link></Menu.Item>
            </SubMenu>
            <SubMenu key="sub3" icon={<TableOutlined />} title="产品管理">
              <Menu.Item key="/products:1"><Link to='/products/'>产品列表</Link></Menu.Item>
              <Menu.Item key="/products:2"><Link to='/products/supplier/'>供应商列表</Link></Menu.Item>
              <Menu.Item key="/products:3"><Link to='/products/payment-requisition/'>供应商付款申请</Link></Menu.Item>
              {/* <Menu.Item key="/products:4"><Link to='/products/receipt-invoice/'>核销发票</Link></Menu.Item> */}
            </SubMenu>
            <SubMenu key="sub4" icon={<WalletOutlined />} title="财务">
              <Menu.Item key="/enterprise:0"><Link to='/enterprise/bill/ad/'>广告费用</Link></Menu.Item>
              {/* <Menu.Item key="/enterprise:0"><Link to='/enterprise/check-accounts/'>核账</Link></Menu.Item> */}
              {/* <SubMenu key="sub4-0" title="收款/付款申请">
                <Menu.Item key="/enterprise:0-0"><Text delete><Link to='#'>收款申请</Link></Text></Menu.Item>
                <Menu.Item key="/enterprise:0-1"><Link to='/enterprise/payment-requisition/'>付款申请</Link></Menu.Item>
              </SubMenu> */}
              <SubMenu key="sub4-1" title="销账">
                <Menu.Item key="/enterprise:1-0-1"><Link to='/enterprise/settlement-of-account/mbill/1'>平台账单管理</Link></Menu.Item>
                {/* <Menu.Item key="/enterprise:1-0-0">
                银行帐单管理 */}
                  {/* <Link to='/enterprise/settlement-of-account/mbill/0'>银行帐单管理</Link> */}
                  {/* </Menu.Item> */}
                {/* <Menu.Item key="/enterprise:1-1"><Link to='/enterprise/settlement-of-account/amounts-receivable/'>应收账款</Link></Menu.Item> */}
                {/* <Menu.Item key="/enterprise:1-1">应收账款</Menu.Item> */}
                <Menu.Item key="/enterprise:1-2"><Link to='/enterprise/settlement-of-account/account-payable/'>应付账款</Link></Menu.Item>
                {/* <Menu.Item key="/enterprise:1-3"><Link to='/enterprise/settlement-of-account/invoices/'>发票</Link></Menu.Item> */}
                {/* <Menu.Item key="/enterprise:1-3">发票</Menu.Item> */}
              </SubMenu>
              <SubMenu key="sub4-2" title="报表明细">
                <Menu.Item key="/enterprise:2-1"><Link to='/enterprise/reports/subsidiary-ledger/'>收入成本</Link></Menu.Item>
                <Menu.Item key="/enterprise:2-2"><Link to='/enterprise/reports/amounts-receivable/'>应收账款</Link></Menu.Item>
                <Menu.Item key="/enterprise:2-3"><Link to='/enterprise/reports/account-payable/'>应付账款</Link></Menu.Item>
                <Menu.Item key="/enterprise:2-4"><Link to='/enterprise/reports/predict-ledger/'>预估收支</Link></Menu.Item>
              </SubMenu>
              <Menu.Item key="/enterprise:4"><Link to='/enterprise/reports/tools/'>核算工具</Link></Menu.Item>
              <Menu.Item key="/enterprise:5"><Link to='/enterprise/reports/tools/u8'>结转</Link></Menu.Item>
              {/* <Menu.Item key="/enterprise:1"><Link to='/enterprise/subsidiary-ledger/'>明细账</Link></Menu.Item> */}
              {/* <Menu.Item key="/enterprise:2"><Link to='#'>总账</Link></Menu.Item> */}
              {/* <Menu.Item key="/enterprise:3"><Link to='/enterprise/profit/'>利润表</Link></Menu.Item> */}
            </SubMenu>
            <SubMenu key="sub5" icon={<NodeIndexOutlined />} title="计调服务">
              {/* <Menu.Item key="/operator:0"><Link to='/operator/itinerary-arrangment/'>行程计划</Link></Menu.Item> */}
              <Menu.Item key="/operator:1"><Link to='/orders/ad/'>广告费用</Link></Menu.Item>
              <Menu.Item key="/operator:2"><Link to='/operator/orders/'>订单列表</Link></Menu.Item>
              <Menu.Item key="/operator:4"><Link to='/operator/check-accounts/'>核账-基础</Link></Menu.Item>
              <Menu.Item key="/operator:5"><Link to='/operator/check-accounts-pro/1/'>核账-工具</Link></Menu.Item>
              {/* <Menu.Item key="/operator:3"><Link to='/operator/account-reconciliation/supplier/'>上传账单</Link></Menu.Item> */}
              {/* <Menu.Item key="/operator:4"><Link to='/orders/refunds/'>退款列表</Link></Menu.Item> */}
            </SubMenu>
            <SubMenu key="sub6" icon={<UserOutlined />} title="帐户管理">
              <Menu.Item key="users">
                <Link to='/users/'>
                  帐户管理
                </Link>
              </Menu.Item>
            </SubMenu>
          </Menu>
        </Sider>
        <Layout className="site-layout">
          <Row>
            <Header className="site-layout-header" style={{ padding: 0 }}>
              <Row type="flex" justify="space-between">
                <Col>
                  {React.createElement(this.state.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                    className: 'trigger',
                    onClick: this.toggle,
                  })}
                </Col>
                <Col>
                  <Space style={{ marginRight: '16px' }}>
                    <Button type='text' icon={<InfoCircleTwoTone />}>
                      <a href='http://47.106.208.187/docs/' target='_blank' style={{marginLeft: '1em'}}>使用指南</a>
                    </Button>
                    <Tooltip title="系统更新" placement="bottom">
                      <Button type="primary" ghost shape="circle" icon={<CloudDownloadOutlined />} onClick={this.forcereload} />
                    </Tooltip>
                    <Tooltip title="退出登录" placement="bottom">
                    <Popconfirm
                      title="退出后需要重新钉钉扫码"
                      onConfirm={this.logout}
                      // onCancel={cancel}
                      okText="退出"
                      // cancelText="No"
                    >
                      <Button type="dashed" danger ghost shape="circle" icon={<LogoutOutlined />}  />
                    </Popconfirm>
                    </Tooltip>
                    <Typography.Link>{uname}</Typography.Link>
                  </Space>
                </Col>
              </Row>
            </Header>
            <Content className="site-layout-content">
              {this.props.children}
            </Content>
            <Footer className="site-layout-footer">广西第五季旅游有限公司</Footer>
          </Row>
        </Layout>
      </Layout></DocumentMeta>
    );
  }
}
